export default "__VITE_ASSET__DXL03hyW__"